<template>
  <div class="blog-preview">
    <h2 class="title" v-html="content.title"></h2>
    <ul v-if="posts">
      <li v-scroll-reveal="{ delay: 150 + i*100}" v-for="(post, i) in posts" :key="post.uid">
        <router-link :to="`${$route.path}/blog/${post.slug}`">
          <div class="post-content">
            <h3>{{post.content.title}}</h3>
          </div>
          <div class="post-photo" :style="getPhoto(post.content.img)"></div>
        </router-link>
      </li>
    </ul>
    <div class="center py-4">
      <custom-btn font="Luckiest Guy, cursive" path="/blog">{{$t('message.news')}}</custom-btn>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      posts: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    getPhoto(img) {
      return {
        backgroundImage: `url(${img})`
      };
    },
    async fetchData() {
      const { data } = await api.get(`cdn/stories`, {
        starts_with: `${this.$i18n.locale}/blog`,
        sort_by: "created_at:desc",
        per_page: 3
      });
      this.posts = data.stories;
    }
  }
};
</script>

<style lang="scss">
.blog-preview {
  position: relative;
  h2 {
    text-align: center;
  }
  > ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 50px;
    width: $content-width;
    margin: auto;
    max-width: $max-width;
    margin-bottom: 20px;
    > li {
      box-shadow: 1px 0px 20px 2px rgba(2, 2, 2, 0.26);
      display: flex;
      align-items: center;
      position: relative;
      min-width: 0;
      height: 300px;
      border-radius: 30px;
      overflow: hidden;
      .post-content {
        transition: background-color 0.2s ease-in-out;
      }
      &:hover {
        .post-photo {
          transform: scale(1.07);
        }
        .post-content {
          transition: background-color 0.2s ease-in-out;
          transition: position 0.2s ease-in-out;
          background-color: rgba(0, 0, 0, 0.4);
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          color: white;
          font-weight: 500;
          z-index: 1;
          height: 100%;
          padding: 3em;
          padding-top: 25%;
          font-family: "Luckiest Guy";
        }
      }
      .post-photo {
        background-position: center;
        background-size: cover;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: scale(1);
        transition: transform 0.3s;
      }
    }
  }
}
#gradient {
  --primary: #{$primary};
  --primary-D2: #{$primary-D2};
}

@media screen and (max-width: 980px) {
  .blog-preview > ul {
    display: block;
    > li {
      width: 500px;
      margin: auto;
      margin-bottom: 30px;
      max-width: $max-width;
    }
  }
}
@media screen and (max-width: $desktop) {
  .blog-preview {
    > ul {
      > li {
        .post-content {
          background-color: rgba(0, 0, 0, 0.4);
          position: absolute;

          bottom: 0;
          right: 0;
          left: 0;
          color: white;
          font-weight: 500;
          z-index: 1;

          padding: 3em;

          font-family: "Luckiest Guy";
          text-align: center;
        }
      }
    }
  }
}
</style>
